var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-3"},[_c('div',[_vm._v("Reservation should be made "+_vm._s(_vm._f("leadtime")(_vm.leadtime))+" ahead")]),_c('span',{staticClass:"caption"},[_vm._v("Set by the business")])])
}
var staticRenderFns = []

export { render, staticRenderFns }